import React, { useState } from 'react'
import CouponDetailPrimaryInfo from 'src/pages/CouponDetailPage/_components/CouponDetailPrimaryInfo'
import UnderLineTab from 'src/components/common/UnderLineTab'
import { Container } from 'src/components/common/Container'
import MixedHtmlData from 'src/components/common/MixedHtmlData'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import styled from 'styled-components'
import Accordion from 'src/components/common/Accordion'
import { GiftHotDealDetailPageProps } from 'src/pages/GiftHotDealPage/GiftHotDealDetailPage/index'
import GiftHeader from 'src/components/layout/GiftHeader/view'
import Footer from 'src/components/layout/Footer'
import { layoutMaxSize } from 'src/styles/mixin'

type CouponDetailUnderLineType = 0 | 1

const GiftHotDealDetailPageView = (props: GiftHotDealDetailPageProps) => {
  const { couponDetailTabData, couponDetailData, openService } = props
  const [activeTab, setActiveTab] = useState<CouponDetailUnderLineType>(0)

  return (
    <S.Background>
      <S.GiftHotDealDetailContainer $option="flex_column">
        <GiftHeader title="상품 상세정보" isBackBtn={true} />
        <CouponDetailPrimaryInfo {...props} />
        <UnderLineTab<CouponDetailUnderLineType>
          items={[
            {
              text: '이용안내',
              contents: (
                <S.CouponDetailUsageWrap>
                  <MixedHtmlData html={couponDetailData?.Introduction} />
                </S.CouponDetailUsageWrap>
              ),
              value: 0,
            },
            {
              text: '상세정보',
              contents: (
                <React.Fragment>
                  <Accordion {...couponDetailTabData?.CouponInfo} type="big" />
                  <Accordion {...couponDetailTabData?.RefundPolicy} type="big" />
                  <Accordion {...couponDetailTabData?.PurchasePolicy} type="big" />
                  <Accordion {...couponDetailTabData?.SellerInfo} type="big" />
                </React.Fragment>
              ),
              value: 1,
            },
          ]}
          state={{ activeTab, setActiveTab }}
        />
        <Footer />
      </S.GiftHotDealDetailContainer>
      <S.CouponDetailFixedContainer $option="flex_row">
        <Button option={ButtonOption3('active')} onClickFn={openService}>
          핫딜 특가 구매하기
        </Button>
      </S.CouponDetailFixedContainer>
    </S.Background>
  )
}
export default GiftHotDealDetailPageView

const S = {
  Background: styled(Container)`
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: var(--black-2);
  `,
  GiftHotDealDetailContainer: styled(Container)`
    ${layoutMaxSize};
    margin-top: 50px;
    align-items: center;
    min-width: 320px;
    background-color: var(--white);
    overflow: hidden;
  `,
  CouponDetailFixedContainer: styled(Container)`
    ${layoutMaxSize};
    padding: 10px;
    position: fixed;
    bottom: 0;
    z-index: 2;
    min-width: 320px;
    background-color: var(--white);
  `,
  CouponDetailUsageWrap: styled(Container)`
    padding: 20px;
  `,
}
